import { sendPdfEmail, trackPDFDownload } from "./stripe";
import { generatePDFBlob } from "./pdf-utils";
import { uploadPDFToSupabaseSimple } from "./supabase-pdf";
import {
  CATEGORY_SECTIONS,
  SPECIFIC_CATEGORY_SECTIONS,
} from "../utils/category_mappings";
import { claimResultsEmail, releaseResultsEmail } from "../utils/resultsEmailGuard";

// Every completed quiz emails the taker their results PDF — first take or retake
// (McKayla + Nina, 2026-09-23 team call). Before this, the email only went out when
// the taker clicked "Get my free results now" on a second screen after results; anyone
// who stopped before that click never got one.
//
// Best-effort: never throws, never blocks the taker from their results.
export async function emailResultsPdf(resultsData: any): Promise<void> {
  const email: string | undefined = resultsData?.email;
  const quizId: number | undefined = resultsData?.quizId;
  if (!email || !quizId) return;
  if (!claimResultsEmail(quizId)) return;

  try {
    const pdfBlob = await generatePDFBlob({
      answers: resultsData.answers || [],
      categoryScores: resultsData.categoryScores || {},
      dominantCategory: resultsData.dominantCategory || "",
      personalInfo: {},
    });

    const emailHash = email.replace(/[^a-zA-Z0-9]/g, "");
    const dateStr = new Date().toISOString().split("T")[0];
    const filename = `personality-profile-${emailHash}-${dateStr}`;
    const { url } = await uploadPDFToSupabaseSimple(pdfBlob, filename);

    try {
      await trackPDFDownload(quizId, email, filename, url);
    } catch {
      // non-critical
    }

    await sendPdfEmail(
      email,
      quizId,
      resultsData,
      "FREE-MONTH",
      CATEGORY_SECTIONS,
      SPECIFIC_CATEGORY_SECTIONS,
      resultsData.dominantCategory,
      resultsData.specificDominantCategory,
      url
    );
  } catch (err) {
    // Let a later visit to this quiz's results try again rather than never sending.
    releaseResultsEmail(quizId);
    console.warn("⚠️ Results PDF email failed (non-critical):", err);
  }
}
